import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { apiService } from '../services/api';
import SEO from '../components/SEO';
import SafeImg from '../components/SafeImg';

const EventsPage = () => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    apiService.events.getAll()
      .then(res => setEvents(res.data))
      .catch(() => {
        setEvents([
          { id: 1, title: 'Annual Function 2026', description: 'Grand cultural program with performances by all classes', eventType: 'Cultural', startDate: '2026-04-15', endDate: '2026-04-15', location: 'School Auditorium' },
          { id: 2, title: 'Sports Day', description: 'Annual sports competition with track and field events', eventType: 'Sports', startDate: '2026-03-25', endDate: '2026-03-25', location: 'School Ground' },
          { id: 3, title: 'Science Exhibition', description: 'Innovation fair showcasing student projects', eventType: 'Academic', startDate: '2026-04-05', endDate: '2026-04-07', location: 'School Hall' }
        ]);
      });
  }, []);

  return (
    <>
      <SEO 
        title="School Events & Activities | Vidya Vatika World School Panipat"
        description="Annual sports day, cultural functions, science exhibitions and more at Vidya Vatika World School. Celebrating excellence and talent."
        keywords="school events Panipat, sports day, cultural programs, school activities Haryana, CBSE school events, annual function"
        canonicalUrl="/events"
        ogImage="/images/og-image.jpg"
      />
      
      <div className="pt-20 min-h-screen bg-gray-50">
      <div className="bg-gradient-to-r from-blue-900 to-blue-800 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold font-display mb-4">School Events</h1>
          <p className="text-xl text-blue-100">Celebrating excellence and talent</p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {events.map((event, index) => (
            <motion.div
              key={event.id}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all"
            >
              {event.imageUrl && (
                <SafeImg src={event.imageUrl} alt="" className="w-full h-48 object-cover" />
              )}
              <div className="bg-accent text-white p-4 text-center">
                <p className="text-sm">{new Date(event.startDate).toLocaleDateString('en-IN', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
              </div>
              <div className="p-6">
                <span className="inline-block bg-blue-100 text-blue-900 text-xs px-3 py-1 rounded-full mb-3">
                  {event.eventType}
                </span>
                <h3 className="text-xl font-bold text-blue-900 mb-2">{event.title}</h3>
                <p className="text-gray-600 mb-4">{event.description}</p>
                <div className="flex items-center text-sm text-gray-500">
                  <i className="fas fa-map-marker-alt mr-2"></i>
                  {event.location}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
    </>
  );
};

export default EventsPage;
